import API from "@/lib/API";

export const leadUploadService = {
  uploadFile: async (data) => {
    return await API.post('/lead-uploads', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  getFilesByLead: async (leadId) => {
    return await API.get(`/lead-uploads/lead/${leadId}`);
  },

  deleteFile: async (fileId) => {
    return await API.delete(`/lead-uploads/${fileId}`);
  }
};
